import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { Recipes } from 'features/Recipes'

export default function RecipesPage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Premium Frozen Raw Dog Food Recipes | We Feed Raw",
  "url": "https://wefeedraw.com/recipes",
  "description": "Explore our selection of raw dog food recipes made with premium ingredients. Enhance your dog's health and vitality with our PhD nutritionist-formulated raw feeding options. Order now from We Feed Raw for fast delivery and top-quality service.",
  "mainEntity": {
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "Recipe",
        "name": "Chicken",
        "description": "A delicious single-protein recipe that's complete and balanced for dogs of all life stages.",
        "image":
          "https://wefeedraw.com/assets/recipes/frozen/product/16oz-frozen-chicken-pouch.webp",
        "url": "https://wefeedraw.com/recipes/chicken"
      },
      {
        "@type": "Recipe",
        "name": "Beef",
        "description": "One of our best-selling single-protein recipes that's complete and balanced for dogs of all life stages.",
        "image":
          "https://wefeedraw.com/assets/recipes/frozen/product/16oz-frozen-beef-pouch.webp",
        "url": "https://wefeedraw.com/recipes/beef"
      },
      {
        "@type": "Recipe",
        "name": "Turkey",
        "description": "A delicious single-protein recipe that's packed with zinc and easily digestible.",
        "image":
          "https://wefeedraw.com/assets/recipes/frozen/product/16oz-frozen-turkey-pouch.webp",
        "url": "https://wefeedraw.com/recipes/turkey"
      },
      {
        "@type": "Recipe",
        "name": "Lamb",
        "description": "Sourced from the clean, green pastures of New Zealand. Grass-fed and packed with flavor.",
        "image":
          "https://wefeedraw.com/assets/recipes/frozen/product/16oz-frozen-lamb-pouch.webp",
        "url": "https://wefeedraw.com/recipes/lamb"
      },
      {
        "@type": "Recipe",
        "name": "Duck",
        "description": "Naturally packed with antioxidants and highly digestible, our duck recipe is a fan favorite.",
        "image":
          "https://wefeedraw.com/assets/recipes/frozen/product/16oz-frozen-duck-pouch.webp",
        "url": "https://wefeedraw.com/recipes/duck"
      },
      {
        "@type": "Recipe",
        "name": "Venison",
        "description": "Sourced from the pristine green pastures of New Zealand. A delicious and novel recipe.",
        "image":
          "https://wefeedraw.com/assets/recipes/frozen/product/16oz-frozen-venison-pouch.webp",
        "url": "https://wefeedraw.com/recipes/venison"
      }
    ]
  }
};

  const jsonLdString = JSON.stringify(schema)

  return (
    <>
      <Head>
        <title>{t('recipes-overview:frozen-page-title')}</title>
        <meta name="title" content={t('recipes-overview:frozen-meta-title')} />
        <meta name="description" content={t('recipes-overview:frozen-meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/recipes" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>
      <main>
        <Recipes />
      </main>
    </>
  )
}
